import React from "react";

export default function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="footer-top">
          <div className="row justify-content-between">
            <div className="col-md-3">
              <img
                className="mb-5"
                src={require("../assets/logo_white.png")}
                alt=""
              />
              <p className="footer-text">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever.Since the 1500s, when an unknown printer.
              </p>
            </div>
            <div className="col-md-3">
              <p className="h6 footer-title">Follow Us</p>
              <p className="footer-text">
                Since the 1500s, when an unknown printer took a galley of type
                and scrambled.
              </p>
              <div className="d-flex">
                <img
                  className="img-fluid mr-3"
                  src={require("../assets/fb.png")}
                  alt="fb-icon"
                />
                <img
                  className="img-fluid"
                  src={require("../assets/twitter.png")}
                  alt="twitter-icon"
                />
              </div>
            </div>
            <div className="col-md-3">
              <p className="h6 footer-title">Contact Us</p>
              <p className="footer-text">
                My Company , 4578 Marmora Road, Glasgow <br /> D04 89GR <br />{" "}
                Call us now: 0123-456-789 Email: support@whatever.com
              </p>
            </div>
          </div>
        </div>
        <hr />
        <div className="footer-bottom row ">
          <div className="col-md-6 col-lg-3">
            <p className="footer-title">Information</p>
            <ul className="footer-nav">
              <li>About Us</li>
              <li>Information</li>
              <li>Privacy Policy</li>
              <li>Terms {"&"} Conditions</li>
            </ul>
          </div>
          <div className="col-md-6 col-lg-3">
            <p className="footer-title">Service</p>
            <ul className="footer-nav">
              <li>About Us</li>
              <li>Information</li>
              <li>Privacy Policy</li>
              <li>Terms {"&"} Conditions</li>
            </ul>
          </div>
          <div className="col-md-6 col-lg-3">
            <p className="footer-title">Extras</p>
            <ul className="footer-nav">
              <li>About Us</li>
              <li>Information</li>
              <li>Privacy Policy</li>
              <li>Terms {"&"} Conditions</li>
            </ul>
          </div>
          <div className="col-md-6 col-lg-3">
            <p className="footer-title">Our Offers</p>
            <ul className="footer-nav">
              <li>About Us</li>
              <li>Information</li>
              <li>Privacy Policy</li>
              <li>Terms {"&"} Conditions</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-copyright border-top ">
        <div className="container  mt-4 d-md-flex justify-content-between">
          <small className="text-secondary">
            © 2018 Ecommerce design by www.bisenbaev.com | Developed by
            @birunidev
          </small>
          <ul className="credit-cards d-flex my-2">
            <li className="mx-1">
              <img src={require("../assets/western.png")} alt="" />
            </li>
            <li className="mx-1">
              <img src={require("../assets/mastercard.png")} alt="" />
            </li>
            <li className="mx-1">
              <img src={require("../assets/paypal.png")} alt="" />
            </li>
            <li className="mx-1">
              <img src={require("../assets/visa.png")} alt="" />
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
